/**
 * @generated SignedSource<<35398bfee2c4cadd9be3ffe7297edbd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "whoamiNext",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StemPendingTransaction",
        "kind": "LinkedField",
        "name": "pending",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vibe",
        "kind": "LinkedField",
        "name": "vibe",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "graphqlWhoamiNextQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "graphqlWhoamiNextQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4b913136e3d8a7dc854227a1314966db",
    "id": null,
    "metadata": {},
    "name": "graphqlWhoamiNextQuery",
    "operationKind": "query",
    "text": "query graphqlWhoamiNextQuery {\n  whoamiNext {\n    id\n    username\n    email\n    version\n    balance\n    pending {\n      hash\n      amount\n    }\n    vibe {\n      username\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7a9410a63fef9ec65caf3bf3b9d6e312";

module.exports = node;
